export default __webpack_public_path__ + "static/media/img-0730-latvia-full-face.a63be421.png";